<div class="sidebar shadow">
  @if (task) {
    <div class="sidebar-entry">
      <div class="sidebar-entry-header">
        <span i18n="@@Planung_TaskDetail_Sidebar_ContactsHeader">Contacts</span>
        <div
          (click)="OnContactAddNew()"
          class="sidebar-button"
          i18n-title="@@Planung_TaskDetail_Sidebar_ContactAddNew"
          title="Add a new contact"
        >
          <i class="fas fa-plus"></i>
        </div>
        @if (ShouldDisplayContactsAddSelf()) {
          <div
            (click)="OnContactAddSelf()"
            class="sidebar-button"
            i18n-title="@@Planung_TaskDetail_Sidebar_ContactAddSelf"
            title="Add yourself to the list of contacts"
          >
            <i class="fas fa-eye"></i>
          </div>
        }
      </div>
      <div class="sidebar-entry-description">
        <span i18n="@@Planung_TaskDetail_Sidebar_ContactsDescription">
          The contacts entered here will be informed by e-mail when changes are
          made to the task.
        </span>
      </div>
      <div class="sidebar-entry-content">
        @for (contact of task.contacts; track contact.id) {
          <div class="contact-card">
            <div class="contact-avatar">
              <app-planung-taskcard-avatar
                [contact]="contact"
              ></app-planung-taskcard-avatar>
            </div>
            <div class="contact-content">
              @if (contact.label) {
                <div class="contact-label">
                  <span>{{ contact.label }}</span>
                </div>
              }
              @if (contact.label) {
                <div class="contact-email">
                  <span
                    ><a [href]="'mailto:' + contact.email">{{
                      contact.email
                    }}</a></span
                  >
                </div>
              }
              @if (!contact.label) {
                <div class="contact-label">
                  <span
                    ><a [href]="'mailto:' + contact.email">{{
                      contact.email
                    }}</a></span
                  >
                </div>
              }
            </div>
            <div class="contact-delete">
              @if (contact.id) {
                <div
                  (click)="OnContactDelete(contact.id)"
                  class="sidebar-button"
                  i18n-title="@@Planung_TaskDetail_Sidebar_ContactDelete"
                  title="Delete this contact"
                >
                  <i class="fas fa-times"></i>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
